import Base from './base'
import { CrmReferences, Recipient } from '../types/loft'

type LoftFromOutlookMessage = {
  to: string
  subject: string
  body: string
  attachments: []
  templateId: number | null
  crmReferences: CrmReferences
  draftMailingId: number | null
  cc: Recipient[]
  additionalTo: string[]
}

type LoftAzurePayload = {
  syncId: string | null
  restItemId: string | null
  restUrl: string
  restToken: string
  templateId: number | null
  to: string
  subject: string
  platform: string
  crmReferences: CrmReferences
  additionalTo: string[]
  inReplyTo: string | undefined
  references: string | undefined
}

export default class MelodyMailings extends Base {
  async loftFromOutlook(message: LoftFromOutlookMessage) {
    const payload = {
      to: message.to,
      subject: message.subject,
      body: message.body,
      attachments: message.attachments,
      email_template_id: message.templateId,
      crm_activity_metadata: message.crmReferences,
      draft_mailing_id: message.draftMailingId,
      cc: message.cc,
      additional_to: message.additionalTo,
    }

    return this.api.post('mailings/outlook/loft.json', payload)
  }

  loftAzure(payload: LoftAzurePayload) {
    return this.api.post('mailings/outlook/loft_azure.json', {
      sync_id: payload.syncId,
      azure_message_id: payload.restItemId,
      rest_url: payload.restUrl,
      rest_token: payload.restToken,
      template_id: payload.templateId,
      to: payload.to,
      subject: payload.subject,
      platform: payload.platform,
      crm_activity_metadata: payload.crmReferences,
      additional_to: payload.additionalTo,
      in_reply_to: payload.inReplyTo,
      references: payload.references,
    })
  }

  sentFromOutlook(id: number) {
    return this.api.put(`mailings/${id}/sent_from_outlook`)
  }
}
